import { ProductBlockGrid as ProductBlockGrid$1 } from './components/ProductBlockGrid/ProductBlockGrid.js';
import { ProductBlockGridCell } from './components/ProductBlockGridCell/ProductBlockGridCell.js';
import { ProductBlockGridContainer } from './components/ProductBlockGridContainer/ProductBlockGridContainer.js';
import { ProductBlockGridDivider } from './components/ProductBlockGridDivider/ProductBlockGridDivider.js';

const ProductBlockGrid = {
    Grid: ProductBlockGrid$1,
    Container: ProductBlockGridContainer,
    Cell: ProductBlockGridCell,
    Divider: ProductBlockGridDivider
};

export { ProductBlockGrid };
//# sourceMappingURL=index.js.map
